module.exports = __webpack_public_path__ + "static/media/daimler-go-drive.6e463305.jpg";